import { render, staticRenderFns } from "./practiceDialog.vue?vue&type=template&id=19748ee6&scoped=true"
import script from "./practiceDialog.vue?vue&type=script&lang=js"
export * from "./practiceDialog.vue?vue&type=script&lang=js"
import style0 from "./practiceDialog.vue?vue&type=style&index=0&id=19748ee6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19748ee6",
  null
  
)

export default component.exports